import { useState } from 'react'
import { MdPlayArrow } from 'react-icons/md'

import {
  FormControl,
  FormControlLabel,
  Grid,
  RadioGroup,
} from '@material-ui/core'
import { useTransferencia } from 'modules/pagamentos/hooks/useTransferencia'
import Scaffold from 'shared/components/Scaffold'
import Text from 'shared/components/Text'
import { colors } from 'shared/styles/colors'

import { StyledRadio, RadioContainer } from './styles'

const options = [
  {
    id: 1,
    label: 'Para TMOV PAY',
    value: 'tmov',
  },
  {
    id: 2,
    label: 'Conta bancária',
    value: 'conta',
  },
]

const TipoTransferencia = (): JSX.Element => {
  const [value, setValue] = useState('')

  const { handleBackButton, setStep, step, setTipoTransferencia } =
    useTransferencia()

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setValue(event.target.value)
    setTipoTransferencia(event.target.value)
  }

  const handleNextButton = () => {
    setStep(step + 1)
  }

  return (
    <Scaffold
      onClickBackButton={handleBackButton}
      onClickNextButton={handleNextButton}
      titleBackButton="Voltar"
      titleNextButton="Próximo"
      isNextButtonDisabled={value === ''}
      showFooterScaffold
      icon={MdPlayArrow}
      color={value !== '' ? colors.green : colors.gray}
      title="Transferir"
    >
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Text>Como você quer transferir?</Text>
        </Grid>
        <Grid item xs={3}>
          <FormControl component="fieldset">
            <RadioGroup value={value} onChange={handleChange}>
              {options?.map(item => (
                <RadioContainer key={item?.id}>
                  <FormControlLabel
                    value={item?.value}
                    control={
                      <StyledRadio
                        value={item?.value}
                        style={{ color: colors?.blue }}
                      />
                    }
                    label={
                      <Text weight="700" color={colors?.grayDark}>
                        {item?.label}
                      </Text>
                    }
                  />
                </RadioContainer>
              ))}
            </RadioGroup>
          </FormControl>
        </Grid>
      </Grid>
    </Scaffold>
  )
}

export default TipoTransferencia
